import type { ReactNode } from 'react';
import { firebaseAuth } from '../../../../lib/firebase';
import { PortalShell } from '../PortalShell';

// THE KYCKCONNECT PORTAL PAGE FRAME: the portal shell plus the scoped Kyck Design System wrapper (`data-kc-theme="kyck"`, see
// src/index.css). ⚠️ The look is that wrapper and nothing else: the staff app never wears it. One definition for every KyckConnect
// portal page (Setup, Dashboard, Reporting), so they cannot drift apart.

export function KcPage({ title, intro, testId, children }: { title: string; intro?: string; testId: string; children: ReactNode }) {
  return (
    <PortalShell signedInAs={firebaseAuth.currentUser?.email ?? null} nav wide>
      <div data-kc-theme="kyck" className="rounded-[18px]" data-testid={testId}>
        <div className="kc-root p-4">
          <h1 className="kc-display">{title}</h1>
          {intro && <p className="mt-1 max-w-prose text-muted-foreground">{intro}</p>}
          <div className="mt-4">{children}</div>
        </div>
      </div>
    </PortalShell>
  );
}
